module.exports = __webpack_public_path__ + "img/selected.f8036c23.svg";